import { BarChartOutlined } from '@ant-design/icons';

import StatsPage from '../pages/StatsPage/StatsPage';

import { SiteMap } from './index';

export const statsRoutes: SiteMap = {
  stats: {
    title: '통계',
    page: StatsPage,
    icon: <BarChartOutlined />,
    key: '/stats',
    role: ['admin'],
    children: [
      {
        label: '월간 주문 통계',
        icon: null,
        key: '/stats/monthly-order?tab=stacked-bar&year=2024',
      },
      {
        label: '일일 주문 통계',
        icon: null,
        key: '/stats/daily-order?tab=line&year=2024',
      },
      {
        label: '상품 가격 차트',
        icon: null,
        key: '/stats/product',
      },
    ],
  },
};
